import type { UseQueryResult } from '@tanstack/react-query';
import { useCallback } from 'react';

import { SimpleFile } from '@hapvida/hapvida-core-components';

import type { DataGridItem } from '@hapvida/hapvida-core-components/src/components/DataGrid/types';

import type {
  BillDetails,
  InvoiceContentProps,
} from '@services/FinancialService';

import { useRedirectUser } from '@hooks';
import { getBillingRedirect } from '@flows/private/financial/helpers/getBillingRedirect';

import { DiscountLink } from '../components';
import { InvoiceButton } from '../components/InvoiceButton';

export const useGridRows = (
  bill: BillDetails,
  reportFilesRows: DataGridItem[],
  invoiceState: UseQueryResult<InvoiceContentProps>,
): DataGridItem[] => {
  const { redirectUser } = useRedirectUser();

  const { data: invoiceData, isLoading: isLoadingInvoice } = invoiceState ?? {};

  const handleRedirectBillLegacyPortal = () => {
    const redirect = getBillingRedirect(bill?.period);
    redirectUser(redirect, `?billing-number=${bill?.billingNumber}`);
  };

  const getInvoiceContentCallback = useCallback(() => {
    if (!invoiceData) {
      return undefined;
    }

    return <InvoiceButton bill={bill} invoice={invoiceData} />;
  }, [bill, invoiceData, isLoadingInvoice]);

  return [
    {
      label: 'Boleto',
      xs: 6,
      sm: 3,
      value: (
        <SimpleFile
          onDownload={handleRedirectBillLegacyPortal}
          filename="Boleto"
        />
      ),
    },
    {
      label: 'Nota Fiscal',
      xs: 6,
      sm: 3,
      value: getInvoiceContentCallback(),
    },
    {
      label: 'Carta de desconto',
      xs: 6,
      sm: 6,
      value: <DiscountLink invoiceNumber={invoiceData?.invoiceNumber} />,
    },
    ...reportFilesRows,
  ];
};
